import { createRoute } from "@tanstack/react-router";
import { ConsultantTerritoriesPage } from "@/components/consultants/consultant-territories-page";
import { divisionScopeKey } from "@/lib/consultant-hub";
import { Route as authenticatedRoute } from "../_authenticated";

function DivisionPage() {
  const { division } = Route.useParams();
  // key forces a fresh page (controls reset) when hopping between divisions.
  return <ConsultantTerritoriesPage key={division} territoryKey={divisionScopeKey(division)} />;
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/consultants/division/$division",
  component: DivisionPage,
});
